module.exports = __webpack_public_path__ + "static/media/uniform.af146fa2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/uniform.svg
// module id = 705
// module chunks = 36